/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export { default as XApiFormsWrapper } from './components/XApiFormsWrapper';
export { default as ConfigureXapiSettingsPage } from './components/ConfigureXapiSettingsPage';
export { default as EditXapiSettingsPage } from './components/EditXapiSettingsPage';
export { default as IntegrateSettings } from './components/IntegrateSettings';
export { default as XapiContextProvider } from './components/XapiContextProvider';
export { getDefaultActorConfig } from './components/XApiV2/formConfigV2';
export const ConfigureXapiSettingsPageDynamic = () => import('./components/ConfigureXapiSettingsPage');
export const EditXapiSettingsPageDynamic = () => import('./components/EditXapiSettingsPage');
export const IntegrateSettingsDynamic = () => import('./components/IntegrateSettings');
export const XapiContextProviderDynamic = () => import('./components/XapiContextProvider');

/**
 *  #################################### Generated content ####################################
 **/
